import { render, staticRenderFns } from "./ItemSummariesComponent.vue?vue&type=template&id=1c43832c&"
import script from "./ItemSummariesComponent.vue?vue&type=script&lang=js&"
export * from "./ItemSummariesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemSummariesComponent.vue?vue&type=style&index=0&id=1c43832c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports